module.exports = __webpack_public_path__ + "Frame396-b3a0c8bb.webp";